import { CANARY_MISSION } from '@/enum/enum'
import FlowbiteIconComponent from '../flowbite-icon/flowbiteIcon'

interface IProps {
  href?: string
  show?: boolean
  buttonCSS?: string
}

export const SeeProfileBtn = ({ href, show ,buttonCSS }: IProps) => {
  return (
    <button
      onClick={(e) => {
        e.preventDefault()
        window.open(`${CANARY_MISSION.BASIC_URL}${href}`, '_blank')
      }}
      className={`${show ? '' : 'hidden'} 
      ${buttonCSS} px-2 flex items-center py-0.5 mt-2  transition-opacity duration-500 ease-in-out rounded-lg bg-gray-900 h-[32px] hover:bg-gray-800`}
    >
      <div
        className={`flex text-white items-center justify-center text-sm font-medium leading-[21px]`}
      >
        See Profile
      </div>
      <FlowbiteIconComponent iconType={'ArrowRight'} className="text-white" />
    </button>
  )
}

export default SeeProfileBtn
